// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../tools/HBuilderX/plugins/uniapp-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-hotel[data-v-5f35b666]{width:100%;height:%?120?%;border-radius:%?12?%;padding:%?20?% %?20?% %?20?% %?30?%;box-shadow:0 %?30?% %?30?% 0 rgba(0,0,0,.02);background-color:#fff;display:flex;align-items:center;justify-content:space-between;margin-bottom:%?20?%}.card-hotel[data-v-5f35b666]:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
